import React from "react";
import { Step } from "../types";

interface FormNavigationButtonsProps {
  currentStep: Step;
  canProceed: boolean;
  formComplete: boolean;
  isSubmitting: boolean;
  onPrev: () => void;
  onNext: () => void;
  onSubmit: () => void;
  hasErrors: boolean;
}

export const FormNavigationButtons: React.FC<FormNavigationButtonsProps> = ({
  currentStep,
  canProceed,
  formComplete,
  isSubmitting,
  onPrev,
  onNext,
  onSubmit,
  hasErrors,
}) => {
  return (
    <div className="grid g-col-10">
      <div className="g-col-12 g-col-md-10">
        {currentStep > 1 && (
          <button type="button" className="text-nowrap" onClick={onPrev}>
            Gå tillbaka
          </button>
        )}
      </div>
      <div className="g-col-12 g-col-md-2">
        {currentStep < 5 ? (
          <button
            type="button"
            className={`button-primary button-navigation text-nowrap ${!canProceed ? "button-disabled" : ""}`}
            onClick={onNext}
            disabled={isSubmitting || hasErrors}
            aria-describedby={hasErrors ? "next-help" : undefined}
          >
            Gå vidare
          </button>
        ) : (
          <>
            {isSubmitting && (
              <span id="submit-help" className="sr-only">
                Sparar aktivitet, vänta…
              </span>
            )}
            <button
              type="button"
              className={`button-primary text-nowrap ${!formComplete ? "button-disabled" : ""}`}
              onClick={onSubmit}
              disabled={!formComplete || isSubmitting}
              aria-describedby={isSubmitting ? "submit-help" : undefined}
            >
              {isSubmitting ? "Skickar in…" : "Bekräfta och skicka"}
            </button>
          </>
        )}
        <span id="next-help" className="sr-only">
          Formuläret innehåller fel och kan inte fortsätta.
        </span>
        <span id="submit-help" className="sr-only">
          Sparar aktivitet, vänta…
        </span>
      </div>
    </div>
  );
};
